import { useState } from 'react'
import { IconSvg } from 'components/common'
import { ContentModal } from 'components/organisms/modals/content-modal'

interface EligibilityErrorModalProps {
	open: boolean
	setOpen: (open: boolean) => void
	icon: string
	title: string
	message?: string
	hintText?: string
}

export function EligibilityErrorModal({ open, setOpen, icon, title, message, hintText }: EligibilityErrorModalProps) {
	return (
		<ContentModal
			open={open}
			setOpen={setOpen}
			isModal
			className="z-50"
			hideCloseButton={false}
		>
			<div className="relative flex flex-col items-center space-y-5">
				<div className="max-w-[400px] text-center">
					<div className="flex justify-center mb-4">
						<div className="w-16 h-16 rounded-full bg-red-500/20 flex items-center justify-center">
							<IconSvg icon={icon} width={32} height={32} className="text-red-500" />
						</div>
					</div>
					<h3 className="text-2xl font-bold mb-4">{title}</h3>
					<div className="text-lg text-primary-text mb-2">{message}</div>
					{hintText && <div className="text-sm text-secondary-text italic mt-4">{hintText}</div>}
				</div>
				<button
					type="button"
					className="px-6 rounded-3xl text-center transition-all duration-300 bg-primary text-white font-bold block w-full h-10 shadow-button backdrop-blur-lg hover:bg-primary-hover"
					onClick={() => setOpen(false)}
				>
					OK
				</button>
			</div>
		</ContentModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export interface EligibilityErrorModalManagedProps {
	icon: string
	title: string
	message?: string
	hintText?: string
}

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'eligibility-error': EligibilityErrorModalManagedProps
	}
}

export function ManagedEligibilityErrorModal({
	onClose,
	...rest
}: EligibilityErrorModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<EligibilityErrorModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
			{...rest}
		/>
	)
}
